/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React from 'react';
import { OV_EMS_CDN } from '../../config/theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var assetRoot = "".concat(OV_EMS_CDN, "media/pages/stv/");
var plpUrl = '/collections/stv-ov';

var LogoSVG = function LogoSVG(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    height: "65",
    viewBox: "0 0 266 65",
    width: "266",
    children: [/*#__PURE__*/_jsx("title", {
      children: "OV Logo"
    }), /*#__PURE__*/_jsxs("g", {
      "aria-hidden": "true",
      fill: "#fff",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m123.548021 64 15.451979-63h-9.335993l-12.366983 51.01277h-.594048l-12.373734-51.01277h-9.329242l15.451979 63z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m97 65c3.865994 0 7-3.1340094 7-7 0-3.865994-3.134006-7-7-7-3.8659906 0-7 3.134006-7 7-.0018325 1.8570755.7350756 3.6386194 2.0482281 4.9517719s3.0946964 2.0500606 4.9517719 2.0482281z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m244.297024 52.01277h-.594048l-12.373734-51.01277h-9.329242l15.451979 63h13.096042l15.451979-63h-9.335993z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m226.007009 51c-2.83245-.0027913-5.387423 1.7016539-6.472647 4.3179627-1.085223 2.6163088-.48678 5.6287645 1.516065 7.6316101 2.002846 2.0028456 5.015301 2.6012879 7.63161 1.5160648s4.320754-3.6401965 4.317963-6.4726466c-.003813-3.8605415-3.13245-6.9891784-6.992991-6.992991z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m68.5034034 65c12.4209619-.0148039 22.4853446-9.9442164 22.4965966-22.1949019h-9.4206625c0 7.1226367-5.8542951 12.8966747-13.0759341 12.8966747-7.2216389 0-13.075934-5.774038-13.075934-12.8966747v-16.2534355h35.5725306v-9.2915136h-35.5725306v-16.260149h-9.4274694v41.8050981c.0150025 12.2517715 10.0813364 22.1801051 22.5034034 22.1949019z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m44.9965825 42.2856002c-.0337369-12.309919-10.0941614-22.2744853-22.4999854-22.2856002v9.3126796c5.2919087-.0027314 10.0641449 3.1586632 12.0905424 8.0094473 2.0263976 4.8507842.9076964 10.4352105-2.8342487 14.1482401-3.741945 3.7130296-9.3698604 4.8230862-14.2584203 2.8123474-4.88856-2.0107388-8.07457401-6.7460981-8.07182139-11.9971142h-9.41923166c-.1414217 8.0676902 4.1152037 15.583327 11.13381405 19.6582257 7.0186104 4.0748988 15.7069266 4.0748988 22.725537 0 7.0186103-4.0748987 11.2752357-11.5905355 11.133814-19.6582257z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m22.5 45v-9.4260436c-7.2205468 0-13.07395644-5.8534096-13.07395644-13.0739564s5.85340964-13.07395644 13.07395644-13.07395644 13.0739564 5.85340964 13.0739564 13.07395644h9.4260436c0-12.4264069-10.0735931-22.5-22.5-22.5s-22.5 10.0735931-22.5 22.5 10.0735931 22.5 22.5 22.5z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m191.5 0c-17.949254 0-32.5 14.5507456-32.5 32.5s14.550746 32.5 32.5 32.5 32.5-14.5507456 32.5-32.5c0-8.6195359-3.424097-16.8860381-9.51903-22.98097039-6.094932-6.0949323-14.361434-9.51902961-22.98097-9.51902961zm0 55.6883572c-12.809409-.0074302-23.187814-10.3968715-23.181629-23.2062812.00619-12.8094097 10.394628-23.18881936 23.204038-23.18387189 12.809411.00495101 23.189825 10.39238519 23.186115 23.20179589-.001783 6.1528822-2.448176 12.0529519-6.800812 16.4018051-4.352636 4.3488531-10.254831 6.7901154-16.407712 6.7865521z"
      })]
    })]
  });
};

LogoSVG.propTypes = {
  className: PropTypes.string.isRequired
};
var heroVideo = {
  captionsFull: "".concat(assetRoot, "embryo_full.vtt"),
  captionsLoop: "".concat(assetRoot, "embryo_loop.vtt"),
  posterFullDesktop: "".concat(assetRoot, "poster_full_desktop.jpg"),
  posterFullMobile: "".concat(assetRoot, "poster_full_mobile.jpg"),
  posterLoopDesktop: "".concat(assetRoot, "poster_loop_desktop.jpg"),
  posterLoopMobile: "".concat(assetRoot, "poster_loop_mobile.jpg"),
  srcFullDesktop: "".concat(assetRoot, "embryo_full_desktop.mp4"),
  srcFullMobile: "".concat(assetRoot, "embryo_full_mobile.mp4"),
  srcLoopDesktop: "".concat(assetRoot, "embryo_loop_desktop.mp4"),
  srcLoopMobile: "".concat(assetRoot, "embryo_loop_mobile.mp4")
};
var brandInfo = {
  description: 'St. Vincent, the multi-faceted artist behind this collection, embodies everything that gets us moving — a creative spirit, endorphin-heavy days, and personal spunk that shines in her music. The STV.OV collection is a system that works together as a whole. Carefully curated silhouettes in universal colors, this modular uniform is made for mixing and matching with ease. <br /><br />Free for creativity. <br />Free for movement. <br />Free for Doing Things.',
  logo: LogoSVG
};
var sizes = [2400, 1600, 1200, 800, 480];
var featureSizes = [900, 600, 480];
var featureProducts = {
  products: [{
    collab: 'STV.OV',
    collabUrl: plpUrl,
    description: [{
      copy: 'Step 1. Form is covering your bases with the STV.OV Bra, '
    }, {
      copy: 'Reversible Bralette, ',
      url: '/products/stv-ov-reversible-bralette?variant=31817679372366'
    }, {
      copy: ' Shorts, and Hi-Rise Leggings. A matte look and brushed feel make these the analog building blocks for your skin. '
    }],
    hoverImageDesktop: {
      alt: 'Product Feature: 001_FORM Reversed',
      sizes: featureSizes,
      src: "".concat(assetRoot, "block_1_desktop_hover.jpg")
    },
    hoverImageMobile: {
      alt: 'Product Feature: 001_FORM Reversed',
      sizes: featureSizes,
      src: "".concat(assetRoot, "block_1_desktop_mobile.jpg")
    },
    imageDesktop: {
      alt: 'Product Feature: 001_FORM',
      sizes: featureSizes,
      src: "".concat(assetRoot, "block_1_desktop.jpg")
    },
    imageMobile: {
      alt: 'Product Feature: 001_FORM',
      sizes: featureSizes,
      src: "".concat(assetRoot, "block_1_mobile.jpg")
    },
    products: [{
      title: 'STV.OV Reversible Bralette',
      url: '/products/stv-ov-reversible-bralette?variant=31817679372366'
    }, {
      title: 'STV.OV Hi-Rise Legging',
      url: '/products/stv-ov-hi-rise-leggings?variant=31817681535054'
    }],
    title: '001_FORM'
  }, {
    collab: 'STV.OV',
    collabUrl: plpUrl,
    description: [{
      copy: 'Step 2. Function means roomy, midweight pieces in versatile tones that blend with anyone and any closet. Layer up with the STV.OV Hoodie and Sweats for a change in scenery or a departure at a moment’s notice. Congrats, your brain is now free to roam about the cabin. '
    }],
    imageDesktop: {
      alt: 'Product Feature: 002_FUNCTION',
      sizes: featureSizes,
      src: "".concat(assetRoot, "block_2_desktop.jpg")
    },
    imageMobile: {
      alt: 'Product Feature: 002_FUNCTION',
      sizes: featureSizes,
      src: "".concat(assetRoot, "block_2_mobile.jpg")
    },
    products: [{
      title: 'STV.OV Hoodie',
      url: '/products/stv-ov-hoodie?variant=31817682223182'
    }, {
      title: 'STV.OV Sweats',
      url: '/products/stv-ov-sweats?variant=31817682681934'
    }],
    title: '002_FUNCTION'
  }, {
    collab: 'STV.OV',
    collabUrl: plpUrl,
    description: [{
      copy: 'Step 3. Focus is stepping out with a confident stride in the weather-resistant STV.OV Trench. It’s ready to throw on in off-beat weather or when the current mood calls for a touch of chic. Great job, your outfit system is fully operational. '
    }],
    imageDesktop: {
      alt: 'Product Feature: 003_FOCUS',
      sizes: featureSizes,
      src: "".concat(assetRoot, "block_3_desktop.jpg")
    },
    imageMobile: {
      alt: 'Product Feature: 003_FOCUS',
      sizes: featureSizes,
      src: "".concat(assetRoot, "block_3_mobile.jpg")
    },
    products: [{
      title: 'STV.OV Trench',
      url: '/products/stv-ov-trench?variant=31817695625294'
    }, {
      title: 'STV.OV Hoodie',
      url: '/products/stv-ov-hoodie?variant=31817682223182'
    }, {
      title: 'STV.OV Sweats',
      url: '/products/stv-ov-sweats?variant=31817682681934'
    }],
    title: '003_FOCUS'
  }]
};
var shopSlider = {
  products: [{
    alt: 'STV.OV Hi-Rise Shorts',
    sizes: sizes,
    src: "".concat(assetRoot, "slide_1_hero.jpg"),
    hoverSrc: "".concat(assetRoot, "slide_1_hover.jpg"),
    url: '/products/stv-ov-hi-rise-shorts?variant=31817673670734'
  }, {
    alt: 'STV.OV Hi-Rise Legging',
    sizes: sizes,
    src: "".concat(assetRoot, "slide_2_hero.jpg"),
    hoverSrc: "".concat(assetRoot, "slide_2_hover.jpg"),
    url: '/products/stv-ov-hi-rise-leggings?variant=31817682321486'
  }, {
    alt: 'STV.OV Hoodie',
    sizes: sizes,
    src: "".concat(assetRoot, "slide_3_hero.jpg"),
    hoverSrc: "".concat(assetRoot, "slide_3_hover.jpg"),
    url: '/products/stv-ov-hoodie?variant=31817682223182'
  }, {
    alt: 'STV.OV Reversible Bralette',
    sizes: sizes,
    src: "".concat(assetRoot, "slide_4_hero.jpg"),
    hoverSrc: "".concat(assetRoot, "slide_4_hover.jpg"),
    url: '/products/stv-ov-reversible-bralette?variant=31817680388174'
  }, {
    alt: 'STV.OV Sweats',
    sizes: sizes,
    src: "".concat(assetRoot, "slide_5_hero.jpg"),
    hoverSrc: "".concat(assetRoot, "slide_5_hover.jpg"),
    url: '/products/stv-ov-sweats?variant=31817681141838'
  }, {
    alt: 'STV.OV Bra',
    sizes: sizes,
    src: "".concat(assetRoot, "slide_6_hero.jpg"),
    hoverSrc: "".concat(assetRoot, "slide_6_hover.jpg"),
    url: '/products/stv-ov-bra?variant=31817680257102'
  }, {
    alt: 'STV.OV Trench',
    sizes: sizes,
    src: "".concat(assetRoot, "slide_7_hero.jpg"),
    hoverSrc: "".concat(assetRoot, "slide_7_hover.jpg"),
    url: '/products/stv-ov-trench?variant=31817695690830'
  }]
};
var footer = {
  cta: 'Shop STV.OV',
  imageDesktop: {
    alt: 'STV OV Trench Action Shot',
    sizes: sizes,
    src: "".concat(assetRoot, "footer_desktop_1.jpg")
  },
  imageMobile: {
    alt: 'STV OV Trench Action Shot',
    sizes: sizes,
    src: "".concat(assetRoot, "footer_mobile.jpg")
  },
  logo: LogoSVG,
  url: plpUrl
};
var props = {
  brandInfo: brandInfo,
  featureProducts: featureProducts,
  footer: footer,
  heroVideo: heroVideo,
  shopSlider: shopSlider
};
export default props;